__turbopack_context__.v({
  "ctaSection": "FQ8qXq_ctaSection",
  "ctaSectionWeb3Theme": "FQ8qXq_ctaSectionWeb3Theme",
  "gridContainerWide": "FQ8qXq_gridContainerWide",
});
